import { cn } from '#app/utils/misc.tsx'

/**
 * Faint 24px×24px CSS grid for the data-driven motif.
 * Renders absolutely positioned inside a relative parent.
 */
export function GridBackdrop({ className }: { className?: string }) {
	return (
		<div
			aria-hidden
			className={cn('pointer-events-none absolute inset-0', className)}
			style={{
				backgroundImage:
					'linear-gradient(to right, var(--m-rule) 1px, transparent 1px), linear-gradient(to bottom, var(--m-rule) 1px, transparent 1px)',
				backgroundSize: '24px 24px',
				opacity: 0.4,
			}}
		/>
	)
}
